import { EXTENSIONS } from "core/consts";
import { Extension, ValueOf } from "core/types";
import { useLoggedCareprovider } from "reduxentities/hooks";

type ExtensionName = ValueOf<typeof EXTENSIONS>;
type ProviderExtensions = Record<ExtensionName, Extension | null>;

export function useGetProviderExtensions(): ProviderExtensions {
  const loggedCareprovider = useLoggedCareprovider();

  const extensions = loggedCareprovider?.extensions || [];

  const result = Object.fromEntries(
    Object.entries(EXTENSIONS).map(([key, value]) => {
      const extension = extensions.find(
        (ext) => ext.integration_type === Number(key),
      );

      return [value, extension || null];
    }),
  ) as ProviderExtensions;

  return result;
}

export function useHasCareproviderExtension(extension: ExtensionName) {
  const extensions = useGetProviderExtensions();
  return extensions[extension];
}
